import { DailyState } from '../types/GameTypes';
import { StorageService } from '../services/StorageService';
import { getTodayString } from '../utils/dateUtils';

/**
 * DailyStateRepository - Handles daily challenge state persistence
 * Manages daily challenge progress and validation
 */
export class DailyStateRepository {
  private storageService: StorageService;
  
  // Storage key
  private static readonly DAILY_STATE_KEY = 'rstlne_daily_state';

  constructor(storageService: StorageService) {
    this.storageService = storageService;
  }

  /**
   * Load daily state
   */
  loadDailyState(): DailyState | null {
    return this.storageService.get<DailyState>(DailyStateRepository.DAILY_STATE_KEY);
  }

  /**
   * Save daily state
   */
  saveDailyState(state: DailyState): void {
    this.storageService.set(DailyStateRepository.DAILY_STATE_KEY, state);
  }

  /**
   * Check if daily state is from today using timezone-aware comparison
   * This replicates the original StateManager.isDailyStateFromToday() behavior
   */
  isDailyStateFromToday(state: DailyState | null): boolean {
    if (!state) {
      return false;
    }
    
    const today = getTodayString(); // Uses local timezone
    return state.date === today;
  }

  /**
   * Create new daily state for today
   * This replicates the original StateManager.createNewDailyState() behavior
   */
  createNewDailyState(): DailyState {
    const today = getTodayString(); // Uses local timezone
    const newState: DailyState = {
      date: today,
      currentWordLength: 5, // Start with 5-letter word
      completed: false,
      results: [],
      totalScore: 0
    };
    
    this.saveDailyState(newState);
    return newState;
  }
}
